import React, { useRef, useState, useContext } from 'react'
import Graphin, { Behaviors, Utils, GraphinContext, Components } from '@antv/graphin';
import { Menu } from 'antd'
import axios from 'axios';
import saveJSON from 'save-json-file';
import InfoCard from '../InfoCard'
import { AddRelation } from '../Modals';
import PubSub from 'pubsub-js';
import { useEffect } from 'react';
import { prUrl } from '../config';

const { ZoomCanvas } = Behaviors;
const { ContextMenu } = Components;

const theme = {
	mode: 'light',
	background: '#F2F2F2',
	nodeSize: 30,
}

const KnowledgeGraph = (props) => {
	const [graphData, setGraphData] = useState({ nodes: [], edges: [] })
	const [graphDataStack, setGraphDataStack] = useState([])
	const [historing, setHistoring] = useState(false)	// 当执行redo或undo操作时设为true，防止将历史动作作为新动作记录到栈内
	const [stackFlag, setStackFlag] = useState(-1)
	const [ItemToShow, setItemToShow] = useState({})
	const [dragFromOut, setDragFromOut] = useState(false)
	const [dragedNode, setDragedNode] = useState({})
	const [isAddRelOpen, setIsAddRelOpen] = useState(false);
	const [sourceNode, setSourceNode] = useState({})
	const [targetNode, setTargetNode] = useState({})
	const [pcodeList, setPcodeList] = useState([])
	const [forceRender, setForceRender] = useState(0)	// 强制更新
	const fileOpenRef = useRef()

	const showAddRel = (status) => {
		setIsAddRelOpen(status);
	};

	const centerNodeStyle = (label) => {
		return {
			keyshape: {
				fill: '#F68C38',
				fillOpacity: 1,
				lineWidth: 0,
				size: 28,
			},
			label: {
				value: label,
				position: 'bottom',
				fill: "#333333",
			}
		}
	};

	const wikiNodeStyle = (label) => {
		return {
			keyshape: {
				fill: '#5687FE',
				fillOpacity: 1,
				lineWidth: 0,
				size: 18,
			},
			label: {
				value: label,
				position: 'bottom',
				fill: "#333333",
			}
		}
	};

	const userNodeStyle = (label) => {
		return {
			keyshape: {
				fill: '#905EE1',
				fillOpacity: 1,
				lineWidth: 0,
				size: 18,
			},
			label: {
				value: label,
				position: 'bottom',
				fill: "#333333",
			}
		}
	};

	const webNodeStyle = (label) => {
		return {
			keyshape: {
				fill: '#1EBD97',
				fillOpacity: 1,
				lineWidth: 0,
				size: 18,
			},
			label: {
				value: label,
				position: 'bottom',
				fill: "#333333",
			}
		}
	};

	const relationStyle = (label) => {
		return {
			label: {
				value: label,
				fontSize: 8,
				fill: "#333333",
			},
			keyshape: {
				stroke: "#656565",
				endArrow: {
					path: 'M 0,0 L 8,4 L 8,-4 Z',
					fill: '#656565',
				},
			}
		}
	}

	// 单击节点
	const ClickBehavior = () => {
		const { graph } = useContext(GraphinContext);
		useEffect(() => {
			const handleClick = (evt) => {
				setItemToShow({})
				const node = evt.item;
				const model = node.getModel();
				if (model.id) {
					setItemToShow(graphData.nodes.find(item => item.id === model.id))
				}
			}
			graph.on('node:click', handleClick);
			return () => {
				graph.off('node:click', handleClick);
			};
		}, []);
		return null;
	};

	// 双击节点
	const DblClickBehavior = () => {
		const { graph, apis } = useContext(GraphinContext);
		useEffect(() => {
			const handleDblClick = (evt) => {
				const node = evt.item;
				const model = node.getModel();
				// 双击聚焦到点击节点上
				apis.focusNodeById(model.id);
				if (model.id[0] === 'Q') {
					axios.get(`https://www.osintsee.com/kg?content=nr&maxrel=30&qcode=${model.id}`).then(    // 限制最多返回30个关系节点
						response => {
							if (response.data && response.data.wikipedia && response.data.wikipedia.length > 0) {
								if (response.data.relatedNodes && response.data.relatedNodes.length > 0) {
									extendGraph(response.data.wikipedia[0], response.data.relatedNodes, '维基')
									// setItemToShow({ id: response.data.wikipedia[0].qcode, ...response.data.wikipedia[0] })
									setItemToShow(graphData.nodes.find(item => item.id === model.id))
									PubSub.publish('search', response.data.wikipedia[0].title)	// 右侧同步google查询该关键词
								}
							}
						},
						error => { console.log("error", error) }
					)
				}else{
					if (model.id[0] === 'R'){
						PubSub.publish('search', model.label)	// 右侧同步google查询该节点的标题
					}
					if (model.id[0] === 'W'){
						PubSub.publish('visit', model.url)	// 右侧同步浏览该网址
					}
				}
			};
			graph.on('node:dblclick', handleDblClick);
			return () => {
				graph.off('node:dblclick', handleDblClick);
			};
		}, []);
		return null;
	};

	// 结束拖拽，保存节点坐标
	const DragNodeEndBehavior = () => {
		const { graph } = useContext(GraphinContext);
		useEffect(() => {
			const saveNodePosition = (evt) => {
				var nodes = graphData.nodes.map(node => {
					if (node.id === evt.items[0].getModel().id) {
						node.fx = evt.items[0].getModel().x
						node.fy = evt.items[0].getModel().y
					}
					return node
				})
				setGraphData({ ...graphData, nodes: nodes })
			}
			graph.on('dragnodeend', saveNodePosition);
			return () => {
				graph.off('dragnodeend', saveNodePosition);
			};
		}, []);
		return null;
	};

	// 单击关系
	const ClickRelationBehavior = () => {
		const { graph } = useContext(GraphinContext);
		useEffect(() => {
			const handleClick = (evt) => {
				const edge = evt.item;
				const model = edge.getModel();
				setItemToShow(graphData.edges.find(item => item.id === model.id))
			}
			graph.on('edge:click', handleClick);
			return () => {
				graph.off('edge:click', handleClick);
			};
		}, []);
		return null;
	};

	// 拖放创建节点
	const CanvasDropBehavior = () => {
		const { graph } = useContext(GraphinContext);
		useEffect(() => {
			const handleCanvasDrop = (evt) => {
				var str = evt.originalEvent.dataTransfer.getData("text")
				if (str.indexOf('http') === 0) {
					if (str.indexOf('wikipedia.org/') > 0) {
						var strList = str.split("wikipedia.org/")[1].split("&")[0].split("/")
						if (strList.length < 2) {
							return
						}
						axios.get(`https://www.osintsee.com/wiki?content=n&article=${decodeURI(strList.slice(1, strList.length).join("/"))}`).then(
							response => {
								if (response.data) {
									extendGraph({ ...response.data.wikipedia[0], fx: evt.x, fy: evt.y }, [], '维基')
								}
							},
							error => { console.log("error", error) }
						)
					} else {
						if (str.indexOf(prUrl)>=0){
							str = str.replace(prUrl,'')
						}
						if (str.indexOf("google.com")>=0){
							str = str.split('?q=').length>1 ? (str.split('?q=')[1].split('&')[0]):str
						}
						extendGraph({ qcode: "w" + new Date().getTime().toString(), title: '网页', url: decodeURI(str), fx: evt.x, fy: evt.y }, [], '网页')	//添加网页节点
					}
				} else {
					extendGraph({ qcode: "R" + new Date().getTime().toString(), title: str, fx: evt.x, fy: evt.y }, [], '自定义')	// 按拖入文本添加节点
				}
				setDragFromOut(false);
			};
			if (dragFromOut) {
				graph.on('canvas:drop', handleCanvasDrop);
				return () => {
					graph.off('canvas:drop', handleCanvasDrop);
				};
			} else {
				graph.off('canvas:drop', handleCanvasDrop);
			}
		}, [dragFromOut]);
		return null;
	};

	// 被拖拽节点
	const NodeDragStartBehavior = () => {
		const { graph } = useContext(GraphinContext);
		useEffect(() => {
			const handleDragStart = (evt) => {
				setDragedNode(evt.item.getModel())
			}
			graph.on('node:dragstart', handleDragStart);
			return () => {
				graph.off('node:dragstart', handleDragStart);
			};
		}, []);
		return null;
	};

	// 在节点上释放拖拽新建关系
	const addRelFunc = (source, target, relType) => {
		var edges = [...graphData.edges]
		edges.push({
			source: source.id, target: target.id, pcode: relType.id, label: relType.value,
			style: relationStyle(relType.value), properties: { id: "E" + new Date().getTime().toString(), 关系类型编码: relType.id, 关系类型名称: relType.value }
		})
		edges = Utils.processEdges([...edges], { poly: 20, loop: 10 });
		setGraphData({ ...graphData, edges: edges, nodes: graphData.nodes.map(node=>{
			// 被拖拽节点弹回原来的位置
			if (node.id === source.id){
				if (source.fx && source.fy){
					node.fx = source.fx;
					node.fy = source.fy;
				}else{
					delete node.fx;
					delete node.fy;
				}
			}
			return node
		})})
		setPcodeList([{ id: relType.id, value: relType.value }, ...pcodeList.filter(item=>item.id!==relType.id)])
		setDragedNode({})
	}
	const NodeDropBehavior = () => {
		const { graph } = useContext(GraphinContext);
		useEffect(() => {
			const handleDrop = (evt) => {
				if (dragFromOut){
					return
				}
				if (Object.keys(dragedNode).length > 0) {
					setSourceNode(dragedNode)
					setTargetNode(evt.item.getModel())
					setIsAddRelOpen(true)
				}
			}
			graph.on('node:drop', handleDrop);
			return () => {
				graph.off('node:drop', handleDrop);
			};
		}, []);
		return null;
	};

	// 画布右键菜单
	const CanvasMenu = (value) => {
		const handleClick = (e) => {
			const { onClose } = value;
			// message.info(`${e.key}`);
			switch (e.key) {
				case "New":
					if (graphData.nodes.length>0 || graphData.edges.length>0){
						saveJSON(graphData, '图谱数据 ' + new Date().toLocaleString()); 	// 先保存当前图谱数据
					}
					setGraphData({ nodes: [], edges: [] })
					setGraphDataStack([])
					setHistoring(false)
					setStackFlag(-1)
					setItemToShow({})
					break;
				case "Open":
					fileOpenRef.current.click();
					break;
				case "Save":
					saveJSON(graphData, '图谱数据 ' + new Date().toLocaleString());
					break;
				case "Layout":
					setForceRender(prev=>prev+1)
					break;
				case "Undo":
					if (stackFlag > 0) {
						setHistoring(true)
						setGraphData({...graphData, ...graphDataStack[stackFlag - 1]})
						setStackFlag(prev => prev - 1)						
					}
					break;
				case "Redo":
					if (stackFlag < graphDataStack.length - 1) {
						setHistoring(true)
						setGraphData({...graphData, ...graphDataStack[stackFlag + 1]})
						setStackFlag(prev => prev + 1)						
					}
					break;
				default:
					break;
			}
			onClose();
		};
		return (<Menu onClick={handleClick}  style={{width:'200}'}}>
			<Menu.Item key="New" disabled={graphData.nodes.length===0 && graphData.edges.length===0 ?true:false}>新建(New)</Menu.Item>
			<Menu.Item key="Open">打开(Open)</Menu.Item>
			<Menu.Item key="Save" disabled={graphData.nodes.length===0 && graphData.edges.length===0 ?true:false}>保存(Save)</Menu.Item>
			<Menu.Item key="Layout">自动布局(Layout)</Menu.Item>
			<Menu.Item key="Undo" disabled={stackFlag<1?true:false}>撤销(Undo)</Menu.Item>
			<Menu.Item key="Redo" disabled={stackFlag===graphDataStack.length-1?true:false}>重做(Redo)</Menu.Item>
		</Menu>);
	};

	// 关系边右键菜单
	const EdgeMenu = (value) => {
		const handleClick = (e) => {
			const { onClose, id } = value;
			switch (e.key) {
				case "Delete":
					const idList = id.split("-");
					if (idList.length > 1) {
						setGraphData({ ...graphData, edges: graphData.edges.filter(item => (item.source !== idList[0]) || (item.target !== idList[1])) })
					}
					break;
				default:
					break;
			}
			onClose();
		};
		return (<Menu onClick={handleClick}>
			<Menu.Item key="Delete">删除关系</Menu.Item>
		</Menu>);
	};

	// 节点右键菜单
	const NodeMenu = (value) => {
		const handleClick = (e) => {
			const { onClose, id } = value;
			switch (e.key) {
				case "Delete":
					setGraphData({ ...graphData, nodes: graphData.nodes.filter(item => item.id !== id), edges: graphData.edges.filter(item => (item.source !== id) && (item.target !== id)) })
					break;
				default:
					break;
			}
			onClose();
		};
		return (<Menu onClick={handleClick}>
			<Menu.Item key="Delete">删除节点</Menu.Item>
		</Menu>);
	};

	useEffect(() => {
		// 初始化关系类型列表
		axios.get(`https://www.osintsee.com/pcode`).then(
			response => {
				if (response.data) {
					setPcodeList(response.data)
				}
			},
			error => { console.log("error", error) }
		)
		// 初始化历史记录栈
		setGraphDataStack([])
	}, [])

	useEffect(() => {
		// 更新历史记录栈
		if (historing) {	// 当前正通过redo或undo改写graphData，所以当前graphData不是新数据，不计入历史栈
			setHistoring(false)	
		} else {
			setGraphDataStack([...graphDataStack, graphData])
			setStackFlag(prev => prev + 1)
		}
	}, [graphData])

	const extendGraph = (center, otherNodes, category) => {
		var nodes = [...graphData.nodes]
		var edges = [...graphData.edges]
		if (center && Object.keys(center).length !== 0 && otherNodes) {
			var style
			var properties = { 名称: center.title }
			switch (category) {
				case '维基':
					style = wikiNodeStyle(center.title);
					break;
				case '自定义':
					style = userNodeStyle(center.title);
					break;
				case '网页':
					style = webNodeStyle(center.title);
					properties.url = center.url
					break;
				default:
					style = userNodeStyle(center.title);
			}
			if (!nodes || nodes.length === 0) {
				nodes.push({ id: center.qcode, style: centerNodeStyle(center.title), label: center.title, properties: properties, category: '主节点', fx: center.fx, fy: center.fy })	// 若图谱为空，则把当前节点作为中心节点加入图谱
			} else {
				if (nodes.findIndex((n) => n.id === center.qcode) === -1) {					
					nodes.push({ id: center.qcode, style: style, label: center.title, properties: properties, category: category, fx: center.fx, fy: center.fy })	// 若图谱不为空，则作为普通节点加入
				}
			}
			for (var d in otherNodes) {
				var index = nodes.findIndex((n) => n.id === otherNodes[d].qcode)
				if (index === -1) {    //没找到
					nodes.push({ id: otherNodes[d].qcode, style: wikiNodeStyle(otherNodes[d].label), label: otherNodes[d].label, properties: { 名称: otherNodes[d].label }, category: category })
				}
				if (otherNodes[d].direction) {
					edges.push({
						source: center.qcode, target: otherNodes[d].qcode,
						pcode: otherNodes[d].pcode ? otherNodes[d].pcode : pcodeList.find(item => item.value === otherNodes[d].relation).id,
						label: otherNodes[d].relation, style: relationStyle(otherNodes[d].relation),
						properties: {
							id: "E" + new Date().getTime().toString(),
							关系类型编码: otherNodes[d].pcode ? otherNodes[d].pcode : pcodeList.find(item => item.value === otherNodes[d].relation).id, 关系类型名称: otherNodes[d].relation
						}
					}) // 正向关系
				} else {
					edges.push({
						source: otherNodes[d].qcode, target: center.qcode,
						pcode: otherNodes[d].pcode ? otherNodes[d].pcode : pcodeList.find(item => item.value === otherNodes[d].relation).id,
						label: otherNodes[d].relation, style: relationStyle(otherNodes[d].relation),
						properties: {
							id: "E" + new Date().getTime().toString(),
							关系类型编码: otherNodes[d].pcode ? otherNodes[d].pcode : pcodeList.find(item => item.value === otherNodes[d].relation).id, 关系类型名称: otherNodes[d].relation
						}
					}) // 反向关系
				}
			}
		}
		edges = Utils.processEdges([...edges], { poly: 20, loop: 10 });
		setGraphData({ nodes: nodes, edges: edges })
	}

	const handleDragEnter = (e) => {
		setDragFromOut(true)
	}

	// 从打开的文件中读取图谱节点和关系数据
	const handleFileChange = (e) => {
		var files = e.target.files
		if (files[0]) {
			var reader = new FileReader();
			reader.readAsText(files[0])
			reader.onload = (e) => {
				var js = JSON.parse(e.target.result)
				if (js.nodes && js.edges) {
					setGraphData({ ...graphData, nodes: js.nodes, edges: js.edges })
					var userPcodes = []
					js.edges.forEach(item => {
						if (item.pcode.length > 8) {	// 用户自定义关系类型
							if (userPcodes.findIndex(e=>e.id===item.pcode)<0) {
								userPcodes.push({ id: item.pcode, value: item.label })
							}
						}
					})
					console.log(userPcodes);
					setPcodeList([...userPcodes, ...pcodeList])
				}
			}
		}
	}

	// 保存节点或边的属性值
	const saveProperties = (id, pcode, propKey, propValue) => {
		if (id.includes("-")) {
			setGraphData({
				...graphData, edges: graphData.edges.map(edge => {
					if (edge.pcode === pcode && edge.source === id.split("-")[0] && edge.target === id.split("-")[1]) {
						edge.properties[propKey] = propValue
						if (propKey==="名称"){
							edge.label = propValue
							edge.style.label.value = propValue
						}
					}
					return edge
				})
			})
		} else {
			setGraphData({
				...graphData, nodes: graphData.nodes.map(node => {
					if (node.id === id) {
						node.properties[propKey] = propValue
						if (propKey==="名称"){
							node.label = propValue
							node.style.label.value = propValue
						}
					}
					return node
				})
			})
		}
		setForceRender(prev=>prev+1)	// 强制渲染，因更新grapData的深层属性可能导致不渲染
	}

	// 保存获取的wiki数据至图谱graphData
	const saveWiki = (qcode, wikiNode) => {
		setGraphData({
			...graphData, nodes: graphData.nodes.map(node => {
				if (node.id === qcode) {
					node.wikiNode = wikiNode
				}
				return node
			})
		});
	}

	// console.log(stackFlag);
	return (
		<div className={props.className === 'graphOnly' ? 'knowledgeGraphOnly' : 'knowledgeGraph'} >
			<div id='echartsdiv' className='echarts' onDragEnter={handleDragEnter}>
				<Graphin key={forceRender} theme={theme} data={graphData} layout={{ type: 'gForce', edgeStrength: 50, linkDistance: 50, }}>
					<ZoomCanvas enabled />
					<ClickBehavior />
					<DblClickBehavior />
					<DragNodeEndBehavior />
					<ClickRelationBehavior />
					<CanvasDropBehavior />
					<NodeDragStartBehavior />
					<NodeDropBehavior />
					<ContextMenu style={{ background: '#fff' }} bindType="canvas">
						{value => {
							return <CanvasMenu {...value} />;
						}}
					</ContextMenu>
					<ContextMenu style={{ background: '#fff' }} bindType="edge">
						{value => {
							return <EdgeMenu {...value} />;
						}}
					</ContextMenu>
					<ContextMenu style={{ background: '#fff' }} bindType="node">
						{value => {
							return <NodeMenu {...value} />;
						}}
					</ContextMenu>
				</Graphin>
				<input
					style={{ display: 'none' }}
					ref={fileOpenRef}
					type="file"
					onChange={handleFileChange}
				/>
			</div>
			<div className='infocard' >
				<InfoCard showItem={ItemToShow} saveProperties={saveProperties} saveWiki={saveWiki} />
			</div>
			<AddRelation isAddRelOpen={isAddRelOpen} showAddRel={showAddRel} addRelFunc={addRelFunc} 
				source={sourceNode} target={targetNode} pcodeList={pcodeList}/>
		</div>
	)
}

export default KnowledgeGraph;
